import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AlertDeleteViewComponent } from '@shared/components/alert-delete-view/alert-delete-view.component';
import { AlertViewComponent } from '@shared/components/alert-view/alert-view.component';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { ButtonFooterListViewComponent } from '@shared/components/button-footer-list-view/button-footer-list-view.component';
import { ControlMessagesComponent } from '@shared/components/control-messages/control-messages.component';
import { ErrorLoginViewComponent } from '@shared/components/error-login-view/error-login-view.component';
import { ErrorViewComponent } from '@shared/components/error-view/error-view.component';
import { LoadingViewComponent } from '@shared/components/loading-view/loading-view.component';
import { NoElementsFilterViewComponent } from '@shared/components/no-elements-filter-view/no-elements-filter-view.component';
import { NoElementsViewComponent } from '@shared/components/no-elements-view/no-elements-view.component';
import { NotificationViewComponent } from '@shared/components/notification-view/notification-view.component';
import { OfPipe } from '@shared/pipes/of.pipe';
import { PhonePipe } from '@shared/pipes/phone.pipe';
import { ScriptPipe } from '@shared/pipes/script.pipe';

const components = [
  AlertViewComponent,
  AlertDeleteViewComponent,
  BreadcrumbComponent,
  ButtonFooterListViewComponent,
  ControlMessagesComponent,
  ErrorViewComponent,
  ErrorLoginViewComponent,
  LoadingViewComponent,
  NoElementsFilterViewComponent,
  NoElementsViewComponent,
  NotificationViewComponent,
  OfPipe,
  PhonePipe,
  ScriptPipe
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    // Material modules
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatProgressSpinnerModule
  ],
  declarations: [...components],
  exports: [components],
  entryComponents: [
    AlertDeleteViewComponent,
    AlertViewComponent,
    LoadingViewComponent,
    NotificationViewComponent
  ]
})
export class SharedModule {}
